import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "toolbox"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "操作时间", -1);

const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账参与方", -1);

const _hoisted_6 = {
  class: "wrapper"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账参与方类型", -1);

const _hoisted_8 = {
  class: "wrapper"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "结算方式", -1);

const _hoisted_10 = {
  class: "wrapper"
};

const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "结算团队", -1);

const _hoisted_12 = {
  class: "wrapper"
};

const _hoisted_13 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_14 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_15 = {
  class: "table-toolbox"
};
const _hoisted_16 = {
  class: "left"
};
const _hoisted_17 = {
  class: "wrapper"
};

const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "结算金额合计：", -1);

const _hoisted_19 = {
  class: "value"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  key: 1
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import Tool from '@/utils/tool';
import Axios from '@/request/createAxiosInstalce';
export default {
  name: 'result-list',

  setup(__props) {
    const router = useRouter();
    onMounted(() => getSupplierList());
    const now = new Date();
    const lastMonthStartDate = Tool.formatTime(new Date(now.getFullYear(), now.getMonth() - 1, 1));
    const lastMonthEndDate = Tool.formatTime(new Date(now.getFullYear(), now.getMonth(), 0));
    const dateRange = ref([lastMonthStartDate, lastMonthEndDate]);
    const search = ref({
      supplierId: '',
      participateRole: '',
      participateName: '',
      settlement_type: ''
    });
    const statistic = ref({});
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '角色',
        field: 'participateRoleName'
      }, {
        title: '分账参与方',
        field: 'participateName'
      }, {
        title: '结算金额',
        field: 'settlementAmount'
      }, {
        title: '实际结算金额',
        field: 'actualSettlementPrice'
      }, {
        title: '提现状态',
        field: 'withdrawStatus'
      }, {
        title: '勾兑订单',
        field: 'orderNum',
        slots: {
          default: 'orderNum'
        }
      }, {
        title: '备注',
        field: 'note'
      }, {
        title: '结算方式',
        field: 'settlementTypeName'
      }, {
        title: '操作时间',
        field: 'createAt'
      }, {
        title: '操作人/审核人',
        field: 'createMan'
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            let range = dateRange.value || ['', ''];

            let query = _objectSpread({
              startTime: range[0],
              endTime: range[1]
            }, search.value);

            return new Promise(resolve => {
              let params = _objectSpread({
                page: page.currentPage,
                pageSize: page.pageSize
              }, query);

              Axios.get('/admin/split/settlement/getSplitSettlementRecordList.json', {
                params
              }).then(res => {
                if (!res.data.success) return;
                statistic.value = res.data.data.settlementStatistics || {};
                resolve({
                  total: res.data.data.total,
                  result: res.data.data.list
                });
              });
            });
          }
        }
      }
    });

    function reset() {
      search.value = {
        supplierId: '',
        participateRole: '',
        participateName: '',
        settlement_type: ''
      };
      dateRange.value = [lastMonthStartDate, lastMonthEndDate];
      table.value.commitProxy('reload');
    }

    const supplierList = ref([]);

    function getSupplierList() {
      // let params = { isFilterManufacture: 1 }
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;
      });
    }

    function toFlowHandle(row, type) {
      let query = {
        startTime: row.orderMinTime,
        endTime: row.orderMaxTime,
        participateId: row.participateId,
        participateRole: row.participateRole,
        settlementStatus: '1,2'
      };
      router.push({
        name: 'sepaccountFlow',
        query
      });
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dateRange.value = $event),
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        style: {
          "flex": "0 0 300px"
        },
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "unlink-panels": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_input, {
        modelValue: search.value.participateName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.value.participateName = $event),
        placeholder: "请输入"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_select, {
        modelValue: search.value.participateRole,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.value.participateRole = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "平台",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "商业公司",
          value: "2"
        }), _createVNode(_component_el_option, {
          label: "销售团队",
          value: "3"
        }), _createVNode(_component_el_option, {
          label: "团队成员（下单人）",
          value: "4"
        }), _createVNode(_component_el_option, {
          label: "团队成员（分账受益人）",
          value: "5"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_select, {
        modelValue: search.value.settlement_type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.value.settlement_type = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "人工结算",
          value: "1"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_el_select, {
        modelValue: search.value.supplierId,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => search.value.supplierId = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item.supplierName,
            value: item.supplierId
          }, null, 8, ["label", "value"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_14]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, "￥" + _toDisplayString(statistic.value.sumSettlementAmount), 1)])])]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        orderNum: _withCtx(({
          row
        }) => [row.orderNum > 0 ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toFlowHandle(row, 'orderNum')
        }, _toDisplayString(row.orderNum), 9, _hoisted_20)) : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(row.orderNum), 1))]),
        _: 1
      }, 16)]);
    };
  }

};